import AdmissionDetail from './pages/AdmissionDetail';

function App() {
  return <AdmissionDetail />;
}

export default App;
